import React from 'react';
interface CTAButtonProps {
  text: string;
  subtitle?: string;
  onClick?: () => void;
  className?: string;
  dark?: boolean;
  href?: string;
}
export function CTAButton({
  text,
  subtitle,
  onClick,
  className = '',
  dark = false,
  href = 'https://www.coneckta.store/cart/47661552926964:1'
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  return <div className={`flex flex-col items-center gap-3 ${className}`} data-id="element-36">
      <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={onClick} className="
          relative
          bg-[#C41E3A] hover:bg-[#A3182F]
          text-white font-bold
          text-lg md:text-xl
          px-8 md:px-12 py-4 md:py-5
          rounded-full
          shadow-lg hover:shadow-xl
          transform hover:scale-[1.03]
          transition-all duration-300 ease-out
          animate-pulse-glow
          cursor-pointer
          w-full max-w-md
          text-center
          inline-block
          no-underline
          focus:outline-none focus:ring-4 focus:ring-[#C41E3A]/40
        " aria-label={text} data-id="element-37">
        {text}
      </a>
      {subtitle && <p className={`text-sm text-center ${dark ? 'text-white/60' : 'text-gray-500'}`} data-id="element-38">
          {subtitle}
        </p>}
    </div>;
}